const globalMeta = {
	siteName: "Your Site Name",
	siteUrl: "https://yoursite.com",
	siteLogo: "https://yoursite.com/images/logo.png",
	email: "email@yoursite.com",
	description: "Default site description."
}

export default globalMeta;